define('vspot-angular/services/group-service',[], function () {
    'use strict';

    return ['$http', 'resources.Group', 'resources.GroupActivity', function ($http, Group, GroupActivity) {

        return {
            /*
             * Get a list of all the groups. Results are paginated.
             *
             * @param sortType - How the data should be sorted from the server.
             *                  The options sent are the language file key for the
             *                  options shown to the user. i.e. "_Alphabetical_", "_Active_".
             *
             * @param hideInactiveGroups - Whether or not to show groups that are inactive.
             * @param currentPage - Which page of the result set to show. 1 is the default.
             * @param itemsPerPage - How many items to show on each page of the result set. 10 is the default.
             *                       An int can be used, or the string "all".
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function(sortType, hideInactiveGroups, currentPage, itemsPerPage) {

                var resource = Group.get({
                    order:                  sortType,
                    hide_inactive_groups:   hideInactiveGroups,
                    page:                   currentPage,
                    items_per_page:         itemsPerPage
                });

                resource.$promise.then(function (result) {
                    if(!result.status) {
                        if(typeof(result.message) === "undefined") {
                            result.message = "_GenericErrorMessage_";
                        }
                    }
                });

                return resource;
            },

            get: function (key) {
                return Group.get({id: key});
            },

            /*
             *  publishableGroups:
             *  Get a list of groups the user can publish to.
             */
            publishableGroups: function () {
                return Group.publishableGroups();
            },

            /*
             * Get a list of activities for a specific group.
             * @param key {int} - the group key
             */
            getActivities: function(key) {
                return GroupActivity.query({group_key: key});
            }
        };
    }];
});

